import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdDalleAssistant } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdDalleAssistantPayload,
  PostwsGenerativeAiAppGroupIdDalleAssistantProps,
} from "./types";
import { isDalleAssistantAsyncResult } from "./validators";

export const postwsGenerativeAiAppGroupIdDalleAssistant = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdDalleAssistant,
  async (
    signal,
    { appGroupId, prompt, jobToken }: PostwsGenerativeAiAppGroupIdDalleAssistantProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdDalleAssistantPayload = {
      job_token: jobToken,
      prompt,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/dalle_assistant`,
      "POST",
      payload,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isDalleAssistantAsyncResult
);
